import { Component } from '@angular/core';

@Component({
  selector: 'reviews-product',
  templateUrl: 'reviews-product.html'
})
export class ReviewsProductComponent {

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/components/reviews-product/reviews-product.ts